import 'whatwg-fetch';
import { urlParams } from './util';

const baseUrl =
  'https://otp.septima.dk/herning-6N1UOBQ4BB/otp/routers/default/plan';

/**
 * Get a route from OTP.
 *
 * @param {Object} payload - { mode: transitMode, from: { lat, lng }, to: { lat, lng } }
 * @param {string} [payload.mode = 'BICYCLE_PARK,WALK,TRANSIT'] - Travel mode, one of 'BICYCLE_PARK,WALK,TRANSIT' || ''TRANSIT,WALK'', || 'BICYCLE', defaults to 'BICYCLE_PARK,WALK,TRANSIT'
 * @param {object} payload.from - coordinate of start point
 * @param {number} payload.from.lat - latitude
 * @param {number} payload.from.lng - longitude
 * @param {object} payload.to - coordinate of end point
 * @param {number} payload.to.lat - latitude
 * @param {number} payload.to.lng - longitude
 * @param {any} payload.startTime - Start time of trip. Must be parsable to Date()
 * @param {number} [payload.numItineraries = 3] - Number of itineraries to return, defaults to 3
 * @param {boolean} payload.arriveBy - if set to true, startTime will instead be end time.
 * @return {Promise} Promise object representing route
 * @example
 *     getRoute({ from,to,startTime,numItineraries: 3, mode: 'BICYCLE_PARK,WALK,TRANSIT',
})
 */
export async function getRoute(payload) {
  let {
    mode = 'BICYCLE_PARK,WALK,TRANSIT',
    from,
    to,
    startTime,
    numItineraries = 3,
    arriveBy = false,
    walkReluctance,
    triangleSafetyFactor,
    triangleTimeFactor,
  } = payload;
  startTime = new Date(startTime);
  let params = {
    fromPlace: `${from.lat},${from.lng}`,
    toPlace: `${to.lat},${to.lng}`,
    time: startTime.toTimeString().substr(0, 5),
    date: `${startTime.getMonth() +
      1}-${startTime.getDate()}-${startTime.getFullYear()}`,
    mode,
    numItineraries,
    maxWalkDistance: 2000,
    arriveBy,
    wheelchair: false,
    locale: 'da',
    // optimize: 'SAFE',
    showIntermediateStops: true,
    walkReluctance: walkReluctance || 4,
    bikeSpeed: 2.78,
    // bikeSwitchTime: 600,
  };
  if (
    typeof triangleSafetyFactor !== 'undefined' &&
    typeof triangleTimeFactor !== 'undefined' &&
    mode === 'BICYCLE'
  ) {
    params = {
      ...params,
      triangleSafetyFactor,
      triangleTimeFactor,
      triangleSlopeFactor: 0,
      optimize: 'TRIANGLE',
    };
  }
  return fetch(`${baseUrl}${urlParams(params)}`, {
    method: 'GET',
  })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else if (response.status !== 404) {
        throw Error(response.statusText);
      }
    })
    .then(function(response) {
      return response;
    });
}
